// extracted by mini-css-extract-plugin
export default {"description":"Description_description__opjpn","description__content":"Description_description__content__tEsao","enableCustomize":"Description_enableCustomize__zabf2"};